const apiKey = 'ae6360471cd946044469960823142736'

const secret = "f78ba087e21202b4"

export {apiKey, secret}